import { useProtected } from "@/hooks";
import { Outlet } from "react-router-dom";

export const LetterHeadsRoot = () => {
  useProtected();

  return <Outlet />;
};
